import { createSlice } from "@reduxjs/toolkit";
import {
  createChartDataState, finishScopedRequest, prepareChartRequest,
  removeScopedSeries, resetChartScope, startScopedRequest,
} from "../../../utils/scopedChartDataUtils";

const initialState = { ...createChartDataState(), scopes: {} };

const sensorAverageDataSlice = createSlice({
  name: "sensorAverageData",
  initialState,
  reducers: {
    fetchSensorAverageDataStart: {
      prepare: prepareChartRequest,
      reducer(state, action) {
        if (startScopedRequest(state, action.payload, action.payload?.measure)) return;
        state.pendingRequests += 1;
        state.isLoading = true;
        state.error = null;
        state.success = false;
      },
    },
    fetchSensorAverageDataSuccess(state, action) {
      const { measure, data } = action.payload;
      const key = measure;
      if (finishScopedRequest(state, action.payload, key)) return;

      state.pendingRequests = Math.max(0, state.pendingRequests - 1);
      state.isLoading = state.pendingRequests > 0;
      state.data = {
        ...state.data,
        [key]: data,
      };
      state.success = true;
    },
    fetchSensorAverageFailure(state, action) {
      if (finishScopedRequest(state, action.payload, action.payload?.measure, true)) return;
      state.pendingRequests = Math.max(0, state.pendingRequests - 1);
      state.isLoading = state.pendingRequests > 0;
      state.error = action.payload;
      state.success = false;
    },
    resetSensorAverageData(state, action) {
      resetChartScope(state, action.payload);
    },
    removeSensorAverageData(state, action) {
      const { measure } = action.payload;
      const key = measure;
      if (removeScopedSeries(state, action.payload, key)) return;
      delete state.data[key];
    },
  },
});

export const {
  fetchSensorAverageDataStart,
  fetchSensorAverageDataSuccess,
  fetchSensorAverageFailure,
  resetSensorAverageData,
  removeSensorAverageData,
} = sensorAverageDataSlice.actions;

export default sensorAverageDataSlice.reducer;
